import { render, staticRenderFns } from "./CarouselProgress.vue?vue&type=template&id=2cb2c0cf"
import script from "./CarouselProgress.vue?vue&type=script&lang=js"
export * from "./CarouselProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports